'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitPql = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _submitForm = require('ui-addon-upgrades/_core/common/api/submitForm');

var _links = require('ui-addon-upgrades/_core/common/navigation/links');

var _createPqlFormData = require('ui-addon-upgrades/_core/common/data/pqlData/createPqlFormData');

var _getUserInfo = require('ui-addon-upgrades/_core/common/api/getUserInfo');

var _tracker = require('ui-addon-upgrades/_core/common/eventTracking/tracker');

var tracker = _interopRequireWildcard(_tracker);

var _wrapWithErrorMonitoring = require('ui-addon-upgrades/_core/common/reliability/wrapWithErrorMonitoring');

var _wrapWithErrorMonitoring2 = _interopRequireDefault(_wrapWithErrorMonitoring);

var _getPqlFormAttributes = require('ui-addon-upgrades/_core/pql/getPqlFormAttributes');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var submitPql = exports.submitPql = (0, _wrapWithErrorMonitoring2.default)('submitPql', function (pqlData) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var formAttributes = (0, _getPqlFormAttributes.getPqlFormAttributes)();
  var formEndpoint = (0, _links.formUrl)(formAttributes);

  return (0, _getUserInfo.getUserInfo)().then(function (_ref) {
    var portal = _ref.portal,
        user = _ref.user;

    var metaData = {
      timestamp: _I18n2.default.moment().valueOf()
    };
    var pqlFormData = (0, _createPqlFormData.createPqlFormData)({
      metaData: metaData,
      upgradeData: pqlData,
      user: user,
      portal: portal,
      options: options
    });

    return (0, _submitForm.submitForm)(formEndpoint, pqlFormData);
  }).then(function () {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('pqlInteraction', _extends({
      action: 'submission succeeded'
    }, pqlData));
  }).catch(function () {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('pqlInteraction', _extends({
      action: 'submission failed'
    }, pqlData));
  });
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/pql/submitPql.js
// module id = 179
// module chunks = 3 4 5